import React from "react";
import { Icon } from "@iconify/react";

const UnitCountOne = ({ data, idx }) => {
  let value = data?.value?.[0]?.value ?? 0;

  const coordinates = data?.coordinates ? JSON.parse(data.coordinates) : {};
  const valueType = coordinates?.datasets?.[0]?.value_type ?? "";

  if (!isNaN(parseFloat(value))) {
    const floatVal = parseFloat(value);
    value = Number.isInteger(floatVal) ? floatVal : floatVal.toFixed(2);
  }

  const icons = [
    "fa6-solid:gauge-high",
    "mdi:view-dashboard",
    "tabler:layout-dashboard",
    "lucide:bar-chart-2",
  ];

  const getContrastColor = (idx) => {
    const contrastColors = [
      "#003366",
      "#800080",
      "#005f6b",
      "#006400",
      "#8B5F33",
    ];

    return contrastColors[idx % contrastColors.length];
  };

  const contrastColor = getContrastColor(idx);

  return (
    <div className="col">
      <div
        className={`card shadow-none border bg-gradient-start-${idx + 1 } h-100`}
      >
        <div className="card-body p-20">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <div>
              <p className="fw-medium text-lg text-primary-light mb-1">
                {data.metric_name?.length > 25
                  ? `${data.metric_name.slice(0, 15)}...`
                  : data.metric_name}
              </p>
              {valueType === "Nos" ? (
                <h6 className="mb-0">
                  <span className="me-2 text-lg">{value}</span>
                  <span className="text-lg">{valueType}</span>
                </h6>
              ) : (
                <h6 className="mb-0">
                  <span  className="text-lg">{valueType}</span>
                  <span  className="text-lg">{value}</span>
                </h6>
              )}
            </div>
            <div
              className={`w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center`}
              style={{
                backgroundColor: contrastColor,
              }}
            >
              <Icon
                icon={icons[idx % icons.length]}
                className="text-white text-2xl mb-0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountOne;
